import './Loading.css';

export default function Loading() {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );
}
